import { render, staticRenderFns } from "./picker-panel.vue?vue&type=template&id=02a8a41d&scoped=true&"
import script from "./picker-panel.vue?vue&type=script&lang=js&"
export * from "./picker-panel.vue?vue&type=script&lang=js&"
import style0 from "./picker-panel.vue?vue&type=style&index=0&id=02a8a41d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a8a41d",
  null
  
)

export default component.exports